import { useState, useRef, useEffect } from 'react';
import './styles.scss';
import { Text } from '../../typography/Text/Text';
import { Title } from '../../typography/Title/Title';

export const ModalAnalysis = ({ isOpen, onClose, children, title }) => {
  const [isModalOpen, setModalOpen] = useState(isOpen);
  const modalRef = useRef(null);

  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    isModalOpen ? modalRef.current?.showModal() : modalRef.current?.close();
  }, [isModalOpen]);

  return (
    <dialog className='modal-analysis' ref={modalRef}>
        <Title tag='h4' className='modal-analysis_title'>{title}</Title>
      {children}
    </dialog>
  );
};
